import { makeEndpointFns } from '../fns';
import { UserAccountNameModel } from '@/user/user';

const { GET } = makeEndpointFns('storeManager');

export const accounts = {
    getAccountName: GET('api/v1/accountManager/{accountGuid}/name', UserAccountNameModel),
};
